import { Box, Chip, Paper, Typography, useTheme } from '@mui/material';
import { Dayjs } from 'dayjs';
import React from 'react';
import { CalendarBooking } from '../SitterCalendar';

interface CalendarCellProps {
  dayNumber: number;
  isCurrentMonth: boolean;
  isToday: boolean;
  date: Dayjs;
  bookings: CalendarBooking[];
  isUnavailable: boolean;
  onClick: (date: Dayjs) => void;
}
// Calendar Cell Component
const CalendarCell: React.FC<CalendarCellProps> = ({
  dayNumber,
  isCurrentMonth,
  isToday,
  date,
  bookings,
  isUnavailable,
  onClick,
}) => {
  const theme = useTheme();

  // Determine background color based on status
  const getBackgroundColor = () => {
    if (!isCurrentMonth) return 'transparent';
    if (isToday) return theme.palette.primary.light + '20'; // Light teal
    if (isUnavailable) return '#ffebee'; // Light red
    if (bookings.some((b) => b.status === 'confirmed')) return theme.palette.primary.light + '20'; // Teal
    if (bookings.some((b) => b.status === 'pending')) return '#fff3e0'; // Light orange
    return '#e8f5e9'; // Light green (available)
  };

  return (
    <Paper
      onClick={() => onClick(date)}
      sx={{
        minHeight: 100,
        p: 1,
        cursor: 'pointer',
        backgroundColor: getBackgroundColor(),
        border: isCurrentMonth ? '1px solid #e0e0e0' : '1px solid transparent',
        transition: 'all 0.2s',
        '&:hover': {
          boxShadow: isCurrentMonth ? 2 : 0,
          transform: isCurrentMonth ? 'translateY(-2px)' : 'none',
        },
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontWeight: isToday ? 700 : isCurrentMonth ? 600 : 400,
          color: isCurrentMonth ? 'text.primary' : 'text.disabled',
          mb: 0.5,
        }}
      >
        {dayNumber}
      </Typography>

      {/* Booking pills */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        {bookings.map((booking) => (
          <Chip
            key={booking.id}
            label={`${booking.petName} - ${booking.service}`}
            size="small"
            sx={{
              height: '20px',
              fontSize: '0.7rem',
              backgroundColor:
                booking.status === 'confirmed'
                  ? theme.palette.primary.main
                  : booking.status === 'pending'
                    ? theme.palette.secondary.main
                    : '#9e9e9e',
              color: 'white',
              '& .MuiChip-label': {
                px: 1,
              },
            }}
          />
        ))}
      </Box>
    </Paper>
  );
};

export default CalendarCell;
